import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { AppState } from '../../../../types/store';
import { ModuleType } from '../../../../types/modules';
import {
  getModuleData,
  getModuleDataByModuleType,
} from '../../../selectors/modules';
import {
  isCurrentUserProfileOwner,
  getProfileOwnerUser,
} from '../../../selectors/users';
import { getDeviationsByIds } from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import { actions as ModalActions } from '@wix/da-shared-react/pkg/Modals';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import { Props as WidgetBoxProps } from '../_partials/WidgetBox';
import { FeedWidgetProps as WidgetProps } from './Feed';
import { Props as BoxProps } from './FeedBox';

type Props = WidgetBoxProps & BoxProps & WidgetProps;
type StateProps = Pick<
  Props,
  | 'items'
  | 'pinnedDeviationId'
  | 'hasMore'
  | 'profileOwnerUser'
  | 'isEmpty'
  | 'isOwner'
>;
type DispatchProps = Pick<Props, 'openSubmitPostPopup'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const moduleData = getModuleData(state, ownProps.moduleId);
  const pinnedDeviationId = getModuleDataByModuleType(
    state,
    ModuleType.FEED_PINNED_DEVIATION
  ).itemId;

  const { results, hasMore } = moduleData;
  const items = getDeviationsByIds(state, results).filter(
    deviation => !deviation.isDeleted
  );
  return {
    items,
    pinnedDeviationId,
    hasMore,
    isEmpty: !items.length,
    profileOwnerUser: getProfileOwnerUser(state),
    isOwner: isCurrentUserProfileOwner(state),
  };
};

const mapDispatchToProps: MapDispatchToProps<
  DispatchProps,
  OwnProps
> = dispatch => ({
  openSubmitPostPopup: () =>
    dispatch(
      ModalActions.pushModal(ModalType.STATUS_UPDATE, { wrapInPopup: false })
    ),
});

export default connect(mapStateToProps, mapDispatchToProps);
